export default __webpack_public_path__ + "4f578d3228569da30e547c1908bbecfd.woff";